import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

function RoleRedirect() {
  const { user, organization, loading, isAuthenticated } = useAuth();

  if (loading) {
    return null; // ou <Spinner />
  }

  if (!isAuthenticated || !user || !organization) {
    return <Navigate to="/login" replace />;
  }

  // Où mène la racine, selon qui se connecte. Personne ne tape une adresse
  // interne : on tape le domaine, et c'est la machine qui sait où envoyer.
  const ACCUEILS = {
    EXPERT: "/tdb",
    NORMAL: "/mon-dossier",
    INTERMEDIAIRE: "/mon-dossier",
  };

  // NORMAL renvoyait vers "/", c'est-à-dire vers ce composant : la racine
  // bouclait sur elle-même et n'affichait rien.
  return <Navigate to={ACCUEILS[organization.role] || "/mon-dossier"} replace />;
}

export default RoleRedirect;
